module.exports = "/assets/logo_sg_substance_designer-a002e57c4257be20dde87cfb5716b5c7.png";